import { ButtonWithLoader } from "@design-system/Button/ButtonWithLoader";
import { Button } from "@design-system/Button/Button";
import { HStack } from "@design-system/HStack/HStack";

interface CreateCategoryGridFooterProps {
    isLoading: boolean;
    onCancel: () => void;
    onAddAndCustomize: () => void;
    onAddSubcategory: () => void;
}

interface CreateCategoryDefaultFooterProps {
    isLoading: boolean;
    isValid: boolean;
    hasAssignSuffix: boolean;
    onCancel: () => void;
}

export const CreateCategoryDefaultFooter = ({
    isLoading,
    isValid,
    hasAssignSuffix,
    onCancel,
}: CreateCategoryDefaultFooterProps) => (
    <HStack as="footer" justify="end" gap={12}>
        <Button
            variant="secondary"
            size="xl"
            type="button"
            disabled={isLoading}
            onClick={onCancel}
        >
            Cancel
        </Button>
        <ButtonWithLoader
            variant="primary"
            size="xl"
            loading={isLoading}
            type="submit"
            disabled={!isValid}
            hotKey="mod+enter"
            hotKeyOptions={{
                description: "Create subcategory",
                preventDefault: true,
                enableOnFormTags: true,
            }}
        >
            Create
            {hasAssignSuffix ? " and assign" : ""}
        </ButtonWithLoader>
    </HStack>
);

export const CreateCategoryGridFooter = ({
    isLoading,
    onCancel,
    onAddAndCustomize,
    onAddSubcategory,
}: CreateCategoryGridFooterProps) => (
    <HStack as="footer" justify="end" gap={12} className="mt-4">
        <Button
            variant="secondary"
            size="md"
            type="button"
            disabled={isLoading}
            onClick={onCancel}
        >
            Cancel
        </Button>
        <ButtonWithLoader
            variant="secondary"
            size="md"
            loading={isLoading}
            type="button"
            disabled={isLoading}
            onClick={onAddAndCustomize}
        >
            Add and customize rule
        </ButtonWithLoader>
        <ButtonWithLoader
            variant="primary"
            size="md"
            loading={isLoading}
            type="button"
            disabled={isLoading}
            onClick={onAddSubcategory}
            hotKey="mod+enter"
            hotKeyOptions={{
                description: "Add subcategory",
                preventDefault: true,
                enableOnFormTags: true,
            }}
        >
            Add subcategory
        </ButtonWithLoader>
    </HStack>
);
